/* SACHISICY ICY theme effects: page freeze transitions, click ripples, snow, scroll reveals, cart bump */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function onReady(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  onReady(function () {
    if (!document.getElementById('icy-freeze')) {
      var fz = document.createElement('div');
      fz.id = 'icy-freeze';
      fz.setAttribute('aria-hidden', 'true');
      fz.innerHTML = '<svg viewBox="0 0 1000 1000" preserveAspectRatio="none"><path d="M500 500 L380 220 L300 60 M500 500 L700 300 L860 180 M500 500 L640 760 L700 960 M500 500 L260 640 L80 720 M500 500 L560 120" fill="none" stroke="rgba(255,255,255,0.8)" stroke-width="2"></path></svg><span>ICY</span>';
      document.body.appendChild(fz);
    }
    if (!document.getElementById('icy-snow')) {
      var sc = document.createElement('canvas');
      sc.id = 'icy-snow';
      sc.setAttribute('aria-hidden', 'true');
      document.body.insertBefore(sc, document.body.firstChild);
    }
    if (root.classList.contains('icy-arriving')) {
      requestAnimationFrame(function () {
        setTimeout(function () {
          root.classList.remove('icy-arriving');
          root.classList.add('icy-arrived');
        }, 120);
      });
    }
    if (!reduce) {
      document.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a) return;
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) === '#' || a.target === '_blank' || a.hasAttribute('download')) return;
        if (/^(mailto|tel|javascript):/i.test(href)) return;
        var url;
        try { url = new URL(a.href, location.href); } catch (err) { return; }
        if (url.origin !== location.origin) return;
        if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
        if (/\/(cart|checkout|account)/.test(url.pathname) && a.closest('form')) return;
        e.preventDefault();
        try { sessionStorage.setItem('icyNav', '1'); } catch (err) {}
        root.classList.add('icy-leaving');
        setTimeout(function () { location.href = url.href; }, 520);
      });
      window.addEventListener('pageshow', function (ev) {
        if (ev.persisted) { root.classList.remove('icy-leaving', 'icy-arriving'); }
      });
    }
    document.addEventListener('pointerdown', function (e) {
      var t = e.target.closest && e.target.closest('.button, button, .icy-cat, .card-wrapper, .header__menu-item, .product-form__input label, .icy-tap');
      if (!t || reduce) return;
      var r = t.getBoundingClientRect();
      var s = Math.max(r.width, r.height) * 2.4;
      var cs = getComputedStyle(t);
      if (cs.position === 'static') t.style.position = 'relative';
      if (cs.overflow !== 'hidden') t.style.overflow = 'hidden';
      var rip = document.createElement('span');
      rip.className = 'icy-ripple';
      rip.style.width = rip.style.height = s + 'px';
      rip.style.left = (e.clientX - r.left) + 'px';
      rip.style.top = (e.clientY - r.top) + 'px';
      t.appendChild(rip);
      setTimeout(function () { rip.remove(); }, 750);
    }, { passive: true });
    var revealables = document.querySelectorAll('.icy-reveal, .card-wrapper, .title-wrapper-with-link, .icy-cat');
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12 });
      revealables.forEach(function (el, i) {
        if (!el.classList.contains('icy-reveal')) el.classList.add('icy-reveal');
        el.style.transitionDelay = ((i % 4) * 0.07) + 's';
        io.observe(el);
      });
    } else {
      revealables.forEach(function (el) { el.classList.add('is-in'); });
    }
    var lastCount = null;
    var box = document.getElementById('cart-icon-bubble');
    if (box) {
      var first = box.querySelector('.cart-count-bubble');
      lastCount = first ? first.textContent.trim() : '0';
      new MutationObserver(function () {
        var b = box.querySelector('.cart-count-bubble');
        var n = b ? b.textContent.trim() : '0';
        if (n !== lastCount && b) { b.classList.remove('icy-bump'); void b.offsetWidth; b.classList.add('icy-bump'); }
        lastCount = n;
      }).observe(box, { childList: true, subtree: true, characterData: true });
    }
    var c = document.getElementById('icy-snow');
    if (c && !reduce) {
      var ctx = c.getContext('2d');
      var flakes = [];
      var W, H, dpr = Math.min(window.devicePixelRatio || 1, 2);
      function size() { W = window.innerWidth; H = window.innerHeight; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
      size();
      window.addEventListener('resize', size);
      var count = W < 700 ? 28 : 56;
      for (var i = 0; i < count; i++) {
        flakes.push({ x: Math.random() * W, y: Math.random() * H, r: 0.8 + Math.random() * 2.4, s: 0.3 + Math.random() * 0.9, d: Math.random() * Math.PI * 2, o: 0.35 + Math.random() * 0.6 });
      }
      var running = true;
      document.addEventListener('visibilitychange', function () { var was = running; running = !document.hidden; if (running && !was) requestAnimationFrame(tick); });
      function tick() {
        if (!running) return;
        ctx.clearRect(0, 0, W, H);
        ctx.shadowColor = 'rgba(120,190,255,.9)';
        ctx.shadowBlur = 8;
        for (var j = 0; j < flakes.length; j++) {
          var f = flakes[j];
          f.y += f.s; f.d += 0.01; f.x += Math.sin(f.d) * 0.4;
          if (f.y > H + 5) { f.y = -5; f.x = Math.random() * W; }
          ctx.beginPath();
          ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
          ctx.fillStyle = 'rgba(220,238,255,' + f.o + ')';
          ctx.fill();
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
  });
})();
